import React from "react";
import Header from "./components/Header";
import FormComponent from "./components/FormComponent";

function App() {
  return (
    <div className="App">
      <Header />
      <FormComponent />
    </div>
  );
}

export default App;
